module.exports = __webpack_public_path__ + "img/sql-logo.0eb51a17.png";